module.exports = __webpack_public_path__ + "img/tdglright.ec2d9c52.png";